<template>
  <v-navigation-drawer
    elevation="5"
    permanent
    class=""
  >
    <div class="bg-base-100 justify-space-between text-center h-full">
      <NuxtLink to="/">
        <template v-if="useRuntimeConfig().public.SHOP_NAME=='LSDOPE'">
          <br>
          <p class="text-6xl header_sitetitle drop-shadow-lg text-secondary">
            LSDope
          </p>
        </template>
        <template v-if="useRuntimeConfig().public.SHOP_NAME=='NyxKnacks'">
          <p class="ml-4 pt-6 text-5xl text-left header_sitetitle drop-shadow">
            Nyx
          </p>
          <p class="mr-5 pb-2 text-5xl text-right header_sitetitle drop-shadow">
            Knacks
          </p>
        </template>
        <br>
      </NuxtLink>
      <ClientOnly>
        <v-item-group
          v-model="currTab"
          class="bg-secondary glass"
        >
          <template
            v-for="(top, idx) in tabs"
            :key="idx"
          >
            <NuxtLink
              v-if="top!=undefined"
              :to="'/shop/products/'+encodeURIComponent(top)"
            >
              <button
                class="w-full text-xl py-2 rounded-0"
              >
                <p class="hover:font-bold">
                  {{ top }}
                </p>
              </button>
            </NuxtLink>
          </template>
        </v-item-group>
        <template #fallback>
          <p>Loading Sidebar</p>
        </template>
      </ClientOnly>
      <div class="menu text-center absolute bottom-2 w-full text-base-content text-lg gap-1">
        <DevOnly>
          <button
            class="hover:font-bold"
            @click="devmenudrawer = !devmenudrawer"
          >
            Dev Menu
          </button>
        </DevOnly>
        <!-- <NuxtLink
          to="/search"
          no-prefetch
        >
          <button class="hover:font-bold">
            Search
          </button>
        </NuxtLink> -->
        
        <NuxtLink to="/checkout" class="flex justify-center">
          <svg
            class="spin"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          ><g
            fill="none"
            fill-rule="evenodd"
          ><path
            d="m0 0h24v24h-24z"
            fill-rule="nonzero"
          /><path
            d="m7.00004 3.33972c1.02576-.59222 2.20878-.5506 3.24046-.13102.6605.26862 1.2829.69834 1.8187 1.25465.55-.53051 1.1648-.94601 1.8054-1.21117.9971-.41264 2.1413-.48636 3.1354.0876.9942.57396 1.5025 1.6018 1.6436 2.67158.0907.68744.0382 1.4276-.1462 2.16922.7497.18586 1.433.51 1.9959.94768.8792.68368 1.5067 1.68744 1.5067 2.87184 0 1.178-.6208 2.1775-1.4926 2.8608-.5451.4272-1.2044.7473-1.928.9377.1969.7219.2493 1.4529.1519 2.1386-.1559 1.0966-.7111 2.1341-1.7312 2.723-1.0258.5923-2.2088.5506-3.2405.1311-.6605-.2687-1.2828-.6984-1.8186-1.2547-.5501.5306-1.1648.9461-1.8055 1.2113-.99705.4126-2.14134.4863-3.13547-.0876-.99412-.574-1.50241-1.6018-1.64357-2.6715-.0907-.6875-.03823-1.4276.14618-2.1692-.74968-.1859-1.43301-.51-1.99588-.9477-.87921-.6837-1.50676-1.6874-1.50676-2.8718 0-1.178.6209-2.17757 1.49268-2.86086.54512-.42726 1.20442-.74737 1.92807-.93775-.19695-.7219-.24938-1.45293-.15192-2.13865.15586-1.09663.71103-2.13412 1.73121-2.72312zm2.487 1.72163c-.59668-.24267-1.11184-.20617-1.48699.01042-.37327.21551-.66121.6399-.75112 1.2725-.081126.570816.0120114 1.2646062.32959656 1.95865074l.11424344.23118926.75069 1.41253-1.59863.05616c-.87094.0306-1.61418.3154-2.11838.7105-.50288.3942-.72645.8558-.72645 1.2868 0 .4332.22597.8975.73447 1.293.46330909.3602727 1.12578347.627405 1.90193103.6919301l.23616897.0131699 1.49966.0432-.6169 1.3676c-.38387.851-.50097 1.6746-.41605 2.3181.08504.6445.3523 1.023.66075 1.2011s.7699.2203 1.37059-.0283c.53982-.22347 1.1240928-.661509 1.6329271-1.2993912l.1666529-.2200088.8759-1.2181.7872 1.2772c.4608.7475 1.0818 1.2558 1.6798 1.499.5967.2427 1.1118.2062 1.487-.0104.3732-.2155.6612-.6399.7511-1.2724.08109-.57087-.01197-1.264617-.3295539-1.9586232l-.1142461-.2311768-.7505-1.4124 1.5984-.0562c.8709-.0307 1.6141-.3154 2.1183-.7106.5029-.3942.7264-.8557.7264-1.2867 0-.4332-.226-.8976-.7344-1.293-.4633636-.3602727-1.1258182-.627405-1.9019391-.6920053l-.2361609-.0131947-1.4997-.04318.6169-1.36759c.3839-.85099.501-1.6746.4161-2.31816-.085-.64453-.3523-1.02306-.6608-1.20114-.3084-.17794026-.7698-.22028-1.3705.02833-.53982.223407-1.124109.6614478-1.6328736 1.29935286l-.1666264.22001714-.876 1.21804-.7872-1.27715c-.4608-.74759-1.0817-1.25586-1.67976-1.49907zm2.51296 2.93859c2.2092 0 4 1.79086 4 3.99996 0 2.2092-1.7908 4-4 4-2.2091 0-3.99996-1.7908-3.99996-4 0-2.2091 1.79086-3.99996 3.99996-3.99996zm0 2c-1.1045 0-2 .89546-2 1.99996 0 1.1046.8955 2 2 2 1.1046 0 2-.8954 2-2 0-1.1045-.8954-1.99996-2-1.99996z"
            fill="oklch(var(--p))"
          /></g></svg>

          <button class="hover:font-bold mx-2">
            View Cart
          </button>
          <svg
            class="spin"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          ><g
            fill="none"
            fill-rule="evenodd"
          ><path
            d="m0 0h24v24h-24z"
            fill-rule="nonzero"
          /><path
            d="m7.00004 3.33972c1.02576-.59222 2.20878-.5506 3.24046-.13102.6605.26862 1.2829.69834 1.8187 1.25465.55-.53051 1.1648-.94601 1.8054-1.21117.9971-.41264 2.1413-.48636 3.1354.0876.9942.57396 1.5025 1.6018 1.6436 2.67158.0907.68744.0382 1.4276-.1462 2.16922.7497.18586 1.433.51 1.9959.94768.8792.68368 1.5067 1.68744 1.5067 2.87184 0 1.178-.6208 2.1775-1.4926 2.8608-.5451.4272-1.2044.7473-1.928.9377.1969.7219.2493 1.4529.1519 2.1386-.1559 1.0966-.7111 2.1341-1.7312 2.723-1.0258.5923-2.2088.5506-3.2405.1311-.6605-.2687-1.2828-.6984-1.8186-1.2547-.5501.5306-1.1648.9461-1.8055 1.2113-.99705.4126-2.14134.4863-3.13547-.0876-.99412-.574-1.50241-1.6018-1.64357-2.6715-.0907-.6875-.03823-1.4276.14618-2.1692-.74968-.1859-1.43301-.51-1.99588-.9477-.87921-.6837-1.50676-1.6874-1.50676-2.8718 0-1.178.6209-2.17757 1.49268-2.86086.54512-.42726 1.20442-.74737 1.92807-.93775-.19695-.7219-.24938-1.45293-.15192-2.13865.15586-1.09663.71103-2.13412 1.73121-2.72312zm2.487 1.72163c-.59668-.24267-1.11184-.20617-1.48699.01042-.37327.21551-.66121.6399-.75112 1.2725-.081126.570816.0120114 1.2646062.32959656 1.95865074l.11424344.23118926.75069 1.41253-1.59863.05616c-.87094.0306-1.61418.3154-2.11838.7105-.50288.3942-.72645.8558-.72645 1.2868 0 .4332.22597.8975.73447 1.293.46330909.3602727 1.12578347.627405 1.90193103.6919301l.23616897.0131699 1.49966.0432-.6169 1.3676c-.38387.851-.50097 1.6746-.41605 2.3181.08504.6445.3523 1.023.66075 1.2011s.7699.2203 1.37059-.0283c.53982-.22347 1.1240928-.661509 1.6329271-1.2993912l.1666529-.2200088.8759-1.2181.7872 1.2772c.4608.7475 1.0818 1.2558 1.6798 1.499.5967.2427 1.1118.2062 1.487-.0104.3732-.2155.6612-.6399.7511-1.2724.08109-.57087-.01197-1.264617-.3295539-1.9586232l-.1142461-.2311768-.7505-1.4124 1.5984-.0562c.8709-.0307 1.6141-.3154 2.1183-.7106.5029-.3942.7264-.8557.7264-1.2867 0-.4332-.226-.8976-.7344-1.293-.4633636-.3602727-1.1258182-.627405-1.9019391-.6920053l-.2361609-.0131947-1.4997-.04318.6169-1.36759c.3839-.85099.501-1.6746.4161-2.31816-.085-.64453-.3523-1.02306-.6608-1.20114-.3084-.17794026-.7698-.22028-1.3705.02833-.53982.223407-1.124109.6614478-1.6328736 1.29935286l-.1666264.22001714-.876 1.21804-.7872-1.27715c-.4608-.74759-1.0817-1.25586-1.67976-1.49907zm2.51296 2.93859c2.2092 0 4 1.79086 4 3.99996 0 2.2092-1.7908 4-4 4-2.2091 0-3.99996-1.7908-3.99996-4 0-2.2091 1.79086-3.99996 3.99996-3.99996zm0 2c-1.1045 0-2 .89546-2 1.99996 0 1.1046.8955 2 2 2 1.1046 0 2-.8954 2-2 0-1.1045-.8954-1.99996-2-1.99996z"
            fill="oklch(var(--p))"
          /></g></svg>
        </NuxtLink>
        <button
          class="hover:font-bold"
          @click="wishdrawer = !wishdrawer"
        >
          Wish List
        </button>
        <NuxtLink to="/account">
          <button class="hover:font-bold">
            My Account
          </button>
        </NuxtLink>
        <button
          class="hover:font-bold"
          @click="themedrawer = !themedrawer"
        >
          Change Site Colors
        </button>
      </div>
    </div>
  </v-navigation-drawer>
  <!--Dev Menu Drawer-->
  <DevOnly>
    <v-navigation-drawer
      v-model="devmenudrawer"
      temporary
    >
      <ul class="menu text-center min-h-full bg-base-100 text-base-content">
        <br>
        <h1>Dev Menu</h1>
        <br>
        <div class="flex flex-col gap-2">
          <button
            class="btn bg-primary glass"
            @click="makeMeAdmin()"
          >
            New Admin
          </button>
          <button
            class="btn bg-primary glass"
            @click="fetchProducts()"
          >
            Products
          </button>
          <button class="btn bg-primary glass">
            !Test CS Case*
          </button>
          <button class="btn glass bg-primary">
            <NuxtLink to="/ash">
              Ash
            </NuxtLink>
          </button>
        </div>
      </ul>
    </v-navigation-drawer>
  </DevOnly>
  <v-navigation-drawer
    v-model="themedrawer"
    temporary
  >
    <ToggleTheme />
  </v-navigation-drawer>
  <v-navigation-drawer
    v-model="wishdrawer"
    temporary
  >
    <Wish />
  </v-navigation-drawer>
</template>

<script setup>
import { useCurrentUser } from 'vuefire';
const currTab=ref('All')
// const shopdrawer=ref()
const wishdrawer=ref()
const devmenudrawer=ref()
const themedrawer = ref(null)


const fetchProducts = async() => {
  if(useCurrentUser().value){
    await $fetch("/api/printify/refresh-printify-products", { method:"POST", headers:{token:(await useCurrentUser().value.getIdToken())} }) //should i await this? //yes otherwise our tag sidebar doesn't update
  } else {
    if(useRuntimeConfig().public.WTFAMI=="DEV"){
      //This will fail on prod if no user token is passed
      await $fetch("/api/printify/refresh-printify-products", { method:"POST"})
    } else{
      return {error: "Unauthorized"}
    }
  }
}

const tabs = ref(['All'])
tabs.value = [
  'All',
  'Candles',
  'Mugs',
  'Puzzles',
  'Journals',
]

//Dynamic Tabs
// const tabs = ref(['All'])
// const productsRef = collection(useFirestore(),'products')
// //Could do a orderBy(__name__,desc/asc) for additional randomization if needed
// const q = query(productsRef,where('visible','==',true),orderBy('sales', 'desc'), orderBy('rating', 'desc'), limit(15))
   
// onMounted(async()=>{
//   const p = await getDocs(q)
//   let allTopTags = []
//   for(let i=0; i<p.size; i++){
//     allTopTags = union(allTopTags, p.docs[i].get('tags'))
//   }
//   allTopTags = uniq(allTopTags)
//   allTopTags = shuffle(allTopTags)
//   if(allTopTags<6){
//     console.log("Not enough tags found :(")
//   }
//   for(let i=0;i<6;i++){
//     tabs.value.push(allTopTags[i])
//   }
// })

const makeMeAdmin = async() =>{
  if(useCurrentUser().value){
    if(useRuntimeConfig().public.WTFAMI=="DEV"){
      await $fetch('/api/userRole', {method:'POST', body:{uid:useCurrentUser().value.uid, roles:['editor','service','admin','super-admin']}})
    } else {
      return {error:'Fuck off'}
    }
  }
}

</script>

<style scoped>

.header_sitetitle {
  font-family: 'Pacifico';
/* text-shadow: 0 5px 9px rgb(var(--v-theme-secondary-lighten-2)), -2px -2px 2px #fff, 0px 0px 3px rgb(var(--v-theme-secondary)); */
  /* font-weight: 200; */
  font-weight: lighter;
  color: oklch(var(--nc));
  text-shadow: 
        -1px -2px 0 oklch(var(--n)),  
        -2px -1px 0 oklch(var(--n)),  
        1px -2px 0 oklch(var(--n)),
        2px -1px 0 oklch(var(--n)),
        -1px 2px 0 oklch(var(--n)),
        -2px 1px 0 oklch(var(--n)),
        1px 2px 0 oklch(var(--n)),
        2px 1px 0 oklch(var(--n));
}

@keyframes color {
  0%   { background: rgb(var(--v-theme-primary-lighten-1)) }
  50%  { background: rgb(var(--v-theme-primary)); }
  100% { background: rgb(var(--v-theme-primary-lighten-1)) }
}

.spin {
  animation: linear spin 5s infinite;
}

@keyframes spin {
  100% {transform: rotate(360deg);}
}

</style>
